import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const disasterStaffMstRepository = RepositoryFactory.get("disasterStaffMst");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setDisasterStaffMst(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadDisasterStaffMst(context, screenId) {
    const list = await disasterStaffMstRepository.list(screenId);
    if (list.status < 300) {
      context.commit("setDisasterStaffMst", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
